import { connect } from 'react-redux';
import Comments from "./Comments";
import {toastr} from 'react-redux-toastr';

import {fetchCommentsByPartner, fetchCommentsByRecipe, postRecipeComment, postPartnerComment} from '../service/comments';
import {recipeCommentsReceived, partnerCommentsReceived} from "../store";

const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
    postComment: (id, label, comment) => {
        postRecipeComment(id, comment)
            .then(() =>
                fetchCommentsByRecipe(label)
                    .then(list => {
                        dispatch(recipeCommentsReceived(list.comments, list.totalComments));
                        toastr.success('Votre commentaire a bien été envoyé');
                        window.scrollTo(0, document.body.scrollHeight);
                    })
                    .catch(() => {
                        toastr.error('Une erreur s\'est produite');
                        return false;
                    })
            );
    },
    postPartnerComment: (id, label, comment) => {
        postPartnerComment(id, comment)
            .then(() =>
                fetchCommentsByPartner(label)
                    .then(list => {
                        dispatch(partnerCommentsReceived(list.comments, list.totalComments));
                        toastr.success('Votre commentaire a bien été envoyé');
                        window.scrollTo(0, document.body.scrollHeight);
                    })
                    .catch(() => {
                        toastr.error('Une erreur s\'est produite');
                        return false;
                    })
            );
    }
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(Comments);



// WEBPACK FOOTER //
// ./src/components/Comments.container.js